function toggleClassMenu() {
	myMenu.classList.add("b-menu-header--animatable");	
	if(!myMenu.classList.contains("b-menu-header--visible")) {
		myMenu.classList.add("b-menu-header--visible");
    $('body').addClass('fixed');
	} else {
		myMenu.classList.remove('b-menu-header--visible');
    $('body').removeClass('fixed');
	}	
}
var overlayhamburger = document.querySelector(".overlayhamburger");
if(overlayhamburger){
  overlayhamburger.addEventListener('click', toggleClassMenu, false);
}

function OnTransitionEnd() {
	myMenu.classList.remove("b-menu-header--animatable");
}
var close = document.querySelector(".b-menu-header__close");                                          
var myMenu = document.querySelector(".b-menu-header");
var oppMenu = document.querySelector(".b-header__hamburger");
myMenu.addEventListener("transitionend", OnTransitionEnd, false);
oppMenu.addEventListener("click", toggleClassMenu, false);
close.addEventListener("click", toggleClassMenu, false);




// WEBPACK FOOTER //
// ./src/js/general/hamburger.js